import { render, staticRenderFns } from "./demoChecklistRecordList.vue?vue&type=template&id=4f7a7328&scoped=true"
import script from "./demoChecklistRecordList.vue?vue&type=script&lang=js"
export * from "./demoChecklistRecordList.vue?vue&type=script&lang=js"
import style0 from "./demoChecklistRecordList.vue?vue&type=style&index=0&id=4f7a7328&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7a7328",
  null
  
)

export default component.exports